import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import Select from 'react-select';
import { useMasterTTEContext } from '../../../controller/admin/data_master/tte';
import { If, Then, Else } from 'react-if';
import ReactLoading from 'react-loading';
import { isAdminReadOnly } from '../../../../utils/roleUtils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (selectedAccount: any) => void;
  selectedAccount: any;
  onAccountChange: (value: any) => void;
  isLoading?: boolean;
}

const ModalTteSertifikat: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  selectedAccount,
  onAccountChange,
  isLoading = false,
}) => {
  const { fetchData: getListAccountTTE } = useMasterTTEContext();
  const { listDataOption: listAccountTTEOption } = useMasterTTEContext().state;

  useEffect(() => {
    if (!isAdminReadOnly()) {
      getListAccountTTE();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="xl">TTE Sertifikat Pengetahuan</ModalHeader>
          <ModalCloseButton size="sm" bg="red.400" color="white" />
          <ModalBody mb="4">
            <Box bg="yellow.100" p="4" mb="4" borderRadius="lg">
              <Flex>
                <svg
                  aria-hidden="true"
                  className="flex-shrink-0 w-5 h-5 text-yellow-700"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  />
                </svg>
                <Box ml="3">
                  <Text
                    fontSize="sm"
                    fontWeight="semibold"
                    textColor="yellow.700"
                  >
                    Tanda Tangan Elektronik
                  </Text>
                  <Text mt="2" textColor="red.700">
                    <Text as="span" fontWeight="bold">
                      PASSPHRASE
                    </Text>{' '}
                    adalah password yang di-set ketika membuat kunci tanda
                    tangan digital Kementrian Agama bersama Badan Siber dan
                    Sandi Nasional (BSSN) Jika kunci salah, maka proses
                    penandatanganan digital akan{' '}
                    <Text as="span" fontWeight="bold">
                      GAGAL
                    </Text>
                  </Text>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Text fontSize="sm" fontWeight="medium" textColor="gray.900">
                Pilih Akun TTE
              </Text>
              <Box mt="3">
                <Select
                  placeholder="Pilih Akun TTE"
                  options={listAccountTTEOption}
                  isClearable
                  onChange={onAccountChange}
                />
              </Box>
            </Box>
            <Flex mt="6" gridGap="1" justifyContent="end">
              <Button
                colorScheme="gray"
                bg="gray.400"
                color="white"
                onClick={onClose}
              >
                Batal
              </Button>
              <Button
                type="button"
                colorScheme="green"
                bg="green.500"
                color="white"
                fontWeight="medium"
                fontSize="xs"
                textTransform="uppercase"
                rounded="md"
                shadow="md"
                px={6}
                py={2.5}
                ml={1}
                opacity={selectedAccount ? 1 : 0.5}
                cursor={selectedAccount ? 'pointer' : 'not-allowed'}
                transition="all 0.15s ease-in-out"
                disabled={!selectedAccount || isLoading}
                onClick={onSubmit}
              >
                <If condition={isLoading}>
                  <Then>
                    <ReactLoading
                      type={'bars'}
                      color={'white'}
                      height={15}
                      width={20}
                    />
                  </Then>
                  <Else>Tanda Tangani Sertifikat Secara Digital</Else>
                </If>
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalTteSertifikat;
